import { ToolbarItem } from "./ToolbarItem";
import { Toolbar } from "../Toolbar";
import { PopupForm } from "../../Frame/PopupForm";

export class ToolbarButton extends ToolbarItem {
    private modalFormName: string;
    private modalFormParams: string;

    public constructor(control: HTMLElement, toolbar: Toolbar) {
        super(control, toolbar);

        this.modalFormName = control.getAttribute("data-modal-form-name");
        this.modalFormParams = control.getAttribute("data-modal-form-params");

        if (this.modalFormName) {
            control.addEventListener("click", () => {
                PopupForm.show(this.modalFormName, this.modalFormParams);
            });
        }
        else if (this.value) {
            control.addEventListener("click", () => {
                toolbar.dispatchButtonClick(this, this.value);
            });
        }
    }

    public setText(text: string) {
        (<HTMLElement>this.control.lastElementChild).innerText = text;
    }

    public enable(enable: boolean) {
        if (enable) {
            this.control.classList.add("pointer");
            this.control.classList.remove("disabled");
            this.control.style.pointerEvents = "unset";
        }
        else {
            this.control.classList.remove("pointer");
            this.control.classList.add("disabled");
            this.control.style.pointerEvents = "none";
        }
    }
}
